import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalState } from "../../types";

const initialState: ModalState = {
    isOpen: false,
    title: '',
    message: '',
    type: 'alert',
    actionId: null
  }

export const modalSlice = createSlice({
    name: 'modal',
    initialState: initialState,
    reducers:{
        openModal: (state, action: PayloadAction<Omit<ModalState, 'isOpen'>>) => {            
            state.isOpen = true
            state.title = action.payload.title
            state.message = action.payload.message
            state.type = action.payload.type
            state.actionId = action.payload.actionId || null
        },
        closeModal: (state) => {
            state.isOpen = false
            state.title = ''
            state.message = ''
            state.type = 'alert'
            state.actionId = null
        }
    }
})

export const { openModal, closeModal } = modalSlice.actions

export default modalSlice.reducer